import styled from '@emotion/styled';
import Box from './layouts/Box';
import {useTranslation} from 'react-i18next';

const StyledPlaceholder = styled(Box)({
  display: 'none',
  '&:only-child': {
    display: 'block',
  },
});

const LonelyPlaceholder = () => {
  const { t } = useTranslation();
  return (
    <StyledPlaceholder>
      {t('Geen gegevens beschikbaar')}
    </StyledPlaceholder>
  );
}

export default LonelyPlaceholder;
